import { Avatar, Group, Text, UnstyledButton } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import { useProfile } from 'init/use-enforce-profile';

type AssignedTo = {
  label: string;
  color: string;
  avatarSrc?: string;
};

export type AssignPillProps = {
  assignedTo: AssignedTo | null;
  emptyLabel: string;
  emptyIcon: Icon;
  onClick: () => void;
};

export const AssignPill = ({
  assignedTo,
  emptyLabel,
  emptyIcon: EmptyIcon,
  onClick,
}: AssignPillProps) => {
  const profile = useProfile();

  const isFilled = assignedTo !== null;
  const label = isFilled ? assignedTo.label : emptyLabel;
  const isAdmin = profile.isAdmin;

  return (
    <UnstyledButton
      onClick={isAdmin ? () => onClick() : undefined}
      disabled={!isAdmin}
      pl={isFilled ? 1 : 8}
      pr="space3"
      py={1}
      style={{
        borderRadius: 999,
        border: '1px solid var(--mantine-color-gray-2)',
        cursor: isAdmin ? 'pointer' : 'default',
        opacity: isFilled || isAdmin ? 1 : 0.7,
        transition: 'background 120ms ease',
      }}
    >
      <Group gap={6} wrap="nowrap">
        {isFilled ? (
          <Avatar
            size={20}
            radius="xl"
            name={label}
            color={assignedTo.color}
            src={assignedTo.avatarSrc}
          />
        ) : (
          <EmptyIcon size={14} stroke={1.8} />
        )}
        <Text size="sm" fw={500} c={isFilled ? undefined : 'dimmed'}>
          {label}
        </Text>
      </Group>
    </UnstyledButton>
  );
};
